import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=8a143de4&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a143de4",
  null
  
)

export default component.exports